import React from 'react'

import './Nfts.css'
const NftsS = () => {

    const scrollContainers = document.querySelectorAll("#infiniteScroll--left");

    scrollContainers.forEach((container) => {
      const scrollWidth = container.scrollWidth;
      let isScrollingPaused = false;
    
      window.addEventListener("load", () => {
        self.setInterval(() => {
          if (isScrollingPaused) {
            return;
          }
          const first = container.querySelector("article");
    
          if (!isElementInViewport(first)) {
            container.appendChild(first);
            container.scrollTo(container.scrollLeft - first.offsetWidth, 0);
          }
          if (container.scrollLeft !== scrollWidth) {
            container.scrollTo(container.scrollLeft + 1, 0);
          }
        }, 15);
      });
    
      function isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        return rect.right > 0;
      }
    
      function pauseScrolling() {
        isScrollingPaused = true;
      }
    
      function resumeScrolling() {
        isScrollingPaused = false;
      }
      const allArticles = container.querySelectorAll("article");
      for (let article of allArticles) {
        article.addEventListener("mouseenter", pauseScrolling);
        article.addEventListener("mouseleave", resumeScrolling);
      }
    });
  return (
    
<div class="container" id="infiniteScroll--left">
<article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/1.png' alt='nfts'/>
      </div>
     
    </div>
  </article>
  
  <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/2.png' alt='nfts'/>
      </div>
     
    </div>
  </article><article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/3.png' alt='nfts'/>
      </div>
    
    </div>
  </article>
  
  <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/4.png' alt='nfts'/>
      </div>
 
    </div>
  </article>

  <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/5.png' alt='nfts'/>
      </div>
 
    </div>
  </article> 

  <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/6.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/7.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/8.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/9.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/10.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/11.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/12.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/13.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/14.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/15.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/16.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/17.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/18.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/19.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/20.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/21.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/22.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/23.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/24.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/25.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/26.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/27.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/28.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/29.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/30.png' alt='nfts'/>
      </div>
 
    </div>
  </article>
  <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/31.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/32.png' alt='nfts'/>
      </div>
 
    </div>
  </article> <article>
    <div class="wrapper">
      <div class="img">

        <img src='images/nfts/33.png' alt='nfts'/>
      </div>
 
    </div>
  </article>

</div>


  )
}

export default NftsS